export default __webpack_public_path__ + "static/media/Group2.fd051919.png";